/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  authenticated: false,
  user: null,
  post_subscription: null,
  is_email_reminder_enabled: null,
  pointsDefaults: {
    points_per_item: 20,
    extra_order_points: 50,
    extra_item_points: 50,
    points_decrease_amount: 100,
    points_max: 3000,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js